import { Service, signal } from '@angular/core';

/**
 * In-memory store for the CSRF token returned in the login/refresh response body.
 * The `csrfToken` cookie is HttpOnly, so the token cannot be read from `document.cookie`;
 * deliberately no localStorage — after a page reload the token is re-obtained via
 * silent refresh (S-01).
 */
@Service()
export class CsrfTokenStore {
  private readonly currentToken = signal<string | null>(null);

  readonly token = this.currentToken.asReadonly();

  set(token: string): void {
    this.currentToken.set(token);
  }

  clear(): void {
    this.currentToken.set(null);
  }
}
